interface IDefaultSetting {
  TITLE: string;
}

const defaultSetting: IDefaultSetting = {
  TITLE: '运营管理',
};
export default defaultSetting;
